import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
    beforeLoad: ({ location }) => {
        throw redirect({ 
            to: '/playbook',
            search: location.search ? Object.fromEntries(new URLSearchParams(location.search)) : undefined
        })
    },
})
